import { IAdvertChannelRepository } from '../../ports/IAdvertChannelRepository';

export class SetAdvertChannelsUseCase {
  constructor(private repo: IAdvertChannelRepository) {}
  execute(advertUUID: string, channelUUIDs: string[], telegramAccountUUIDs?: string[]) { return this.repo.setForAdvert(advertUUID, channelUUIDs, telegramAccountUUIDs); }
}
